import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Send, MessageSquare } from 'lucide-react';
import { SUPPORT_CONTENT } from '../../utils/constants';
import { fadeInUp, staggerContainer, staggerItem } from '../../utils/animations';

const SupportSection = () => {
  const [form, setForm] = useState({
    name: '',
    reference: '',
    issueType: '',
    message: '',
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert('Thank you for your feedback. Our team will review and respond shortly.');
    setForm({ name: '', reference: '', issueType: '', message: '' });
  };

  return (
    <section id="support" className="py-24 bg-neutral-50">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          className="text-center mb-12"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: '-100px' }}
        >
          <motion.div
            className="inline-flex items-center justify-center w-12 h-12 bg-neutral-200 rounded-xl mb-4"
            variants={fadeInUp}
          >
            <MessageSquare size={24} className="text-neutral-600" />
          </motion.div>
          <motion.h2
            className="text-3xl sm:text-4xl text-neutral-900 leading-tight mb-4"
            style={{ fontFamily: "'Livvic', sans-serif", fontWeight: 700 }}
            variants={fadeInUp}
          >
            {SUPPORT_CONTENT.heading}
          </motion.h2>
          <motion.p
            className="text-neutral-600 text-lg leading-relaxed"
            style={{ fontFamily: "'Livvic', sans-serif" }}
            variants={fadeInUp}
          >
            {SUPPORT_CONTENT.text}
          </motion.p>
        </motion.div>

        <motion.form
          onSubmit={handleSubmit}
          className="space-y-6 bg-white rounded-2xl p-8 border border-neutral-100 shadow-sm"
          variants={staggerContainer}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: '-100px' }}
        >
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            <motion.div variants={staggerItem}>
              <label className="block text-sm font-medium text-neutral-700 mb-2" style={{ fontFamily: "'Livvic', sans-serif" }}>Name</label>
              <input
                type="text"
                name="name"
                value={form.name}
                onChange={handleChange}
                required
                className="w-full px-4 py-3 rounded-lg border border-neutral-200 bg-neutral-50 text-neutral-900 focus:outline-none focus:ring-2 focus:ring-brand-500 focus:border-transparent transition-all"
                style={{ fontFamily: "'Livvic', sans-serif" }}
                placeholder="Your name"
              />
            </motion.div>
            <motion.div variants={staggerItem}>
              <label className="block text-sm font-medium text-neutral-700 mb-2" style={{ fontFamily: "'Livvic', sans-serif" }}>Order / Inquiry Reference</label>
              <input
                type="text"
                name="reference"
                value={form.reference}
                onChange={handleChange}
                className="w-full px-4 py-3 rounded-lg border border-neutral-200 bg-neutral-50 text-neutral-900 focus:outline-none focus:ring-2 focus:ring-brand-500 focus:border-transparent transition-all"
                style={{ fontFamily: "'Livvic', sans-serif" }}
                placeholder="Reference number (if applicable)"
              />
            </motion.div>
          </div>

          <motion.div variants={staggerItem}>
            <label className="block text-sm font-medium text-neutral-700 mb-2" style={{ fontFamily: "'Livvic', sans-serif" }}>Issue Type</label>
            <select
              name="issueType"
              value={form.issueType}
              onChange={handleChange}
              required
              className="w-full px-4 py-3 rounded-lg border border-neutral-200 bg-neutral-50 text-neutral-900 focus:outline-none focus:ring-2 focus:ring-brand-500 focus:border-transparent transition-all"
              style={{ fontFamily: "'Livvic', sans-serif" }}
            >
              <option value="">Select issue type</option>
              {SUPPORT_CONTENT.issueTypes.map((type, i) => (
                <option key={i} value={type}>{type}</option>
              ))}
            </select>
          </motion.div>

          <motion.div variants={staggerItem}>
            <label className="block text-sm font-medium text-neutral-700 mb-2" style={{ fontFamily: "'Livvic', sans-serif" }}>Message</label>
            <textarea
              name="message"
              value={form.message}
              onChange={handleChange}
              required
              rows={5}
              className="w-full px-4 py-3 rounded-lg border border-neutral-200 bg-neutral-50 text-neutral-900 focus:outline-none focus:ring-2 focus:ring-brand-500 focus:border-transparent transition-all resize-none"
              style={{ fontFamily: "'Livvic', sans-serif" }}
              placeholder="Describe your concern or feedback..."
            />
          </motion.div>

          <motion.div variants={staggerItem}>
            <button
              type="submit"
              className="w-full sm:w-auto inline-flex items-center justify-center space-x-2 bg-neutral-800 text-white px-8 py-3 rounded-lg font-medium hover:bg-neutral-900 transition-colors"
            >
              <span>Submit Feedback</span>
              <Send size={16} />
            </button>
          </motion.div>
        </motion.form>
      </div>
    </section>
  );
};

export default SupportSection;